var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 19.2267V10.5C9.99998 7.28 12.6133 4.66667 15.8333 4.66667C19.0533 4.66667 21.6666 7.28 21.6666 10.5V19.2267C24.49 17.3367 26.3333 14.14 26.3333 10.5C26.3333 4.69 21.6433 0 15.8333 0C10.0233 0 5.33331 4.69 5.33331 10.5C5.33331 14.14 7.17665 17.3367 9.99998 19.2267ZM32.96 30.03L22.3666 24.7567C21.97 24.5933 21.55 24.5 21.1066 24.5H19.3333V10.5C19.3333 8.56333 17.77 7 15.8333 7C13.8966 7 12.3333 8.56333 12.3333 10.5V35.56C3.93331 33.7867 4.07331 33.81 3.76998 33.81C3.04665 33.81 2.39331 34.1133 1.92665 34.58L0.083313 36.4467L11.61 47.9733C12.24 48.6033 13.1266 49 14.0833 49H29.9266C31.6766 49 33.03 47.7167 33.2866 46.0133L35.0366 33.7167C35.06 33.5533 35.0833 33.39 35.0833 33.25C35.0833 31.8033 34.1966 30.5433 32.96 30.03Z",
    fill: "#E5E6E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.89ee3567.svg";
export { ForwardRef as ReactComponent };